import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon awesome-bookmark-delivery",
  "use": "icon-Icon awesome-bookmark-delivery-usage",
  "viewBox": "0 0 15 20.056",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 20.056\" id=\"icon-Icon awesome-bookmark-delivery\"><defs><style>#icon-Icon awesome-bookmark-delivery .a{fill:#5f708e;stroke:#5f708e;stroke-width:1.5px;}</style></defs><path class=\"a\" d=\"M0,18V1.688A1.687,1.687,0,0,1,1.688,0H11.813A1.687,1.687,0,0,1,13.5,1.688V18L6.75,14.062Z\" transform=\"translate(0.75 0.75)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol